import { useState } from 'react';
import { useTwilio } from '@frontend/features/communications/TwilioContextProvider/provider';

export const useDtmf = () => {
  const { sendDtmfTones } = useTwilio();
  const [input, setInput] = useState('');

  const handleButtonClick = (digit: string) => {
    if (digit.trim()) {
      setInput((prev) => `${prev}${digit}`);
      sendDtmfTones(digit);
    }
  };

  const clearInput = () => {
    setInput('');
  };

  return {
    input,
    handleButtonClick,
    clearInput,
  };
};
